/**
 * Коды интеграций реестра.
 *
 * Код интеграции — свойство домена, а не деталь экрана: по нему запрашиваются сведения об
 * интеграции и опознаётся карточка со своим блоком. Локальная константа того же значения у
 * каждого потребителя даёт столько мест, где живёт код, сколько экранов его знают, — и
 * переименование на бэкенде чинится не везде.
 */

/** Анонимизатор персональных данных: страница настройки классов и блок карточки */
export const S1_ANONYMIZER_CODE = 's1-anonymizer';

/** Звонки Bitrix24: блок отбора звонков на карточке интеграции */
export const C2_BITRIX_CODE = 'c2_bitrix24';

/** Атрибуты и записи разговоров C1 CRM: источник аудио для отправки на транскрибацию */
export const C1_CRM_CODE = 'c1_crm';

/** Данные калькулятора из C1 CRM: включённость открывает действие их загрузки */
export const C1_CRM_CALCULATOR_CODE = 'c1_crm_calculator';

/** Голосовой бот C1: блок прогрузки диалогов и журнала прогрузок */
export const C1_BOT_CODE = 'c1_bot';

/** Отправка звонков C1 на транскрибацию: блок отбора звонков и отправки */
export const C1_TO_ASR_CODE = 'c1_to_asr';

/** Загрузка готовых ASR-транскрибаций: блок запуска загрузки и журнала */
export const C3_ASR_DEMO_CODE = 'c3_asr_demo';
